<!--
  Cartão único, redação variável. A ordem dos ramos é a regra de negócio: "padronização em andamento" é um
  caso ESPECÍFICO de "documento enviado e nada validado" e vem primeiro — quem acabou de subir arquivo no
  onboarding precisa saber que a IA está trabalhando, não ser mandado conferir uma tela que ainda está vazia
  para ele.

  `ignore-export` só nos botões: a mensagem explica um PDF/Excel vazio e merece sair no relatório; um botão
  de navegação, não.
-->
<div class="dfp-empty-state" [class.dfp-empty-state--no-data]="!statusUnavailable">
  <div class="dfp-empty-state__icon-title"></div>

  @if (!progressResolved() && !statusUnavailable) {
    <!--
      Resumo ainda não respondeu: nenhuma redação é escolhida aqui. Sem este gate, `progress()` nulo cai no
      ramo por documento enviado e a empresa que está EXTRAINDO pode receber "Nenhum documento contábil
      enviado" com atalho para o Onboarding — mandando o usuário reenviar o que já está sendo processado.
    -->
  } @else if (progress()?.isProcessing) {
    <h4>Estamos padronizando seus documentos</h4>
    <p>
      Encontramos documentos em padronização para esta empresa. Esse processo pode levar de
      <strong>5 a 10 minutos</strong>. Tente novamente em instantes — ou deixe esta tela aberta: os
      dados aparecem aqui automaticamente assim que estiverem disponíveis.
    </p>
    <div class="dfp-empty-state__action ignore-export">
      <app-button
        label="Verificar agora"
        icon="pi pi-refresh"
        [fitContent]="true"
        [isLoading]="isChecking()"
        loadingText="Verificando..."
        [disabled]="isChecking()"
        (sendClick)="checkNow()" />
    </div>
  } @else if (statusUnavailable) {
    <h4>
      O DRE e Balanço cadastrados estão em avaliação por nossa equipe. <br />
      Em breve, os dados estarão disponíveis nesta página.
    </h4>
    <p>
      <span class="dfp-empty-state__icon-alert"> </span>Lembre-se de manter os documentos em dia
      para visualizar dados atualizados.
    </p>
  } @else if (hasSentDocuments() === false) {
    <h4>Nenhum documento contábil enviado</h4>
    <p>
      Sem DRE, balanço ou faturamento enviados, não há o que extrair. O envio acontece no
      <strong>Onboarding</strong> da empresa ou em <strong>Gestão de documentos contábeis</strong>.
    </p>
    <div class="dfp-empty-state__action ignore-export">
      <app-button
        *appHasPermission="onboardingPermission"
        label="Ir para o Onboarding"
        icon="pi pi-arrow-right"
        iconPosition="right"
        [fitContent]="true"
        (sendClick)="goToOnboarding()" />
    </div>
  } @else if (hasSentDocuments() === true) {
    <h4>Os documentos desta empresa ainda não têm dados validados</h4>
    <p>
      Há documentos enviados, mas nenhum com extração já revisada e validada — é a validação que
      libera os números para esta tela. Confira o andamento em
      <strong>Padronização de dados contábeis</strong>.
    </p>
    <div class="dfp-empty-state__action ignore-export">
      <app-button
        *appHasPermission="standardizationPermission"
        label="Verificar"
        icon="pi pi-arrow-right"
        iconPosition="right"
        [fitContent]="true"
        (sendClick)="goToStandardization()" />
    </div>
  } @else {
    <h4>Esta empresa não possui dados extraídos validados</h4>
    <p>
      Confira o andamento em <strong>Padronização de dados contábeis</strong>: é lá que os
      documentos contábeis são extraídos pelo Cog IA, revisados e validados antes de alimentarem
      esta tela.
    </p>
    <div class="dfp-empty-state__action ignore-export">
      <app-button
        *appHasPermission="standardizationPermission"
        label="Verificar"
        icon="pi pi-arrow-right"
        iconPosition="right"
        [fitContent]="true"
        (sendClick)="goToStandardization()" />
    </div>
  }
</div>
